import * as actions from './actionTypes';

export const showModal = () => ({
  type: actions.SHOW_MODAL,
});

export const hideModal = () => ({
  type: actions.HIDE_MODAL,
});
